
import { mapActions } from 'vuex';

import { REGIONS } from '@/modules/region/domain/region';
import { LANDING_PAGE_IDS, QUIZ_VARIANTS } from '@/modules/tour/domain/tour';

export default {
  components: {
    LandingPagesLoseWeight: () => import('@/components/landing-pages/lose-weight/lose-weight'),
  },
  head() {
    return {
      title: this.$t('landingPage.meta.title'),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('landingPage.meta.description'),
        },
      ],
    };
  },
  computed: {
    shouldShowLandingPage() {
      return this.regionAndLanguageEnabled && [QUIZ_VARIANTS.NUTRITION_WEEKLY_START].includes(this.getQuizVariant);
    },
    regionAndLanguageEnabled() {
      return [REGIONS.eu, REGIONS.uk, REGIONS.join, REGIONS.latam, REGIONS.br, REGIONS.us, REGIONS.ca].includes(
        this.$countryCode,
      );
    },
    landingVariant() {
      return String(QUIZ_VARIANTS.NUTRITION_WEEKLY_START);
    },
  },
  created() {
    this.initializeLandingPage();
  },
  mounted() {
    this.handleLandingPageRedirect();
  },
  methods: {
    ...mapActions('quiz', ['setQuizVariantAction', 'setLandingPageIdAction']),
    initializeLandingPage() {
      this.setQuizVariantAction(this.landingVariant);
      this.setLandingPageIdAction(LANDING_PAGE_IDS.NUTRITION_WEEKLY_START);
    },
    handleLandingPageRedirect() {
      if (!this.shouldShowLandingPage) {
        window.location.href = this.$getUrl('home');
      } else {
        this.landingPageGtmHandler();
      }
    },
  },
};
